import { TPrivacyPolicy } from './types';

export const PRIVACY_POLICY: TPrivacyPolicy = [
  {
    id: 1,
    title: 'privacy_policy.label',
    content: [
      {
        id: 1,
        type: 'section',
        paragraphs: [
          {
            id: 1,
            type: 'text',
            content: 'privacy_policy.section_1.paragraph_1',
          },
          {
            id: 2,
            type: 'text',
            content: 'privacy_policy.section_1.paragraph_2',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    title: 'privacy_policy.section_2.title',
    content: [
      {
        id: 1,
        type: 'section',
        paragraphs: [
          {
            id: 1,
            type: 'text',
            content: 'privacy_policy.section_2.paragraph_1.content',
          },
          {
            id: 2,
            type: 'list',
            items: [
              {
                id: 1,
                content: 'privacy_policy.section_2.paragraph_1.li_1',
              },
              {
                id: 2,
                content: 'privacy_policy.section_2.paragraph_1.li_2',
              },
              {
                id: 3,
                content: 'privacy_policy.section_2.paragraph_1.li_3',
              },
              {
                id: 4,
                content: 'privacy_policy.section_2.paragraph_1.li_4.content',
                type: 'list',
                items: [
                  {
                    id: 1,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_1',
                  },
                  {
                    id: 2,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_2',
                  },
                  {
                    id: 3,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_3',
                  },
                  {
                    id: 4,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_4',
                  },
                  {
                    id: 5,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_5',
                  },
                  {
                    id: 6,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_6',
                  },
                  {
                    id: 7,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_7',
                  },
                  {
                    id: 8,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_8',
                  },
                  {
                    id: 9,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_9',
                  },
                  {
                    id: 10,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_10',
                  },
                  {
                    id: 11,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_11',
                  },
                  {
                    id: 12,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_12',
                  },
                  {
                    id: 13,
                    content: 'privacy_policy.section_2.paragraph_1.li_4.nestedLi_13',
                  },
                ],
              },
            ],
          },
          {
            id: 3,
            type: 'text',
            content: 'privacy_policy.section_2.paragraph_3',
          },
          {
            id: 4,
            type: 'text',
            content: 'privacy_policy.section_2.paragraph_4',
          },
          {
            id: 5,
            type: 'text',
            content: 'privacy_policy.section_2.paragraph_5',
          },
        ],
      },
    ],
  },
  {
    id: 3,
    title: 'privacy_policy.section_3.title',
    content: [
      {
        id: 1,
        type: 'section',
        paragraphs: [
          {
            id: 1,
            type: 'text',
            content: 'privacy_policy.section_3.paragraph_1',
          },
          {
            id: 2,
            type: 'text',
            content: 'privacy_policy.section_3.paragraph_2',
          },
          {
            id: 3,
            type: 'text',
            content: 'privacy_policy.section_3.paragraph_3',
          },
          {
            id: 4,
            type: 'text',
            content: 'privacy_policy.section_3.paragraph_4',
          },
          {
            id: 5,
            type: 'text',
            content: 'privacy_policy.section_3.paragraph_5',
          },
        ],
      },
    ],
  },
  {
    id: 4,
    title: 'privacy_policy.section_4.title',
    content: [
      {
        id: 1,
        type: 'section',
        paragraphs: [
          {
            id: 1,
            type: 'text',
            content: 'privacy_policy.section_4.paragraph_1',
          },
          {
            id: 2,
            type: 'list',
            items: [
              {
                id: 1,
                content: 'privacy_policy.section_4.paragraph_2.li_1',
              },
              {
                id: 2,
                content: 'privacy_policy.section_4.paragraph_2.li_2',
              },
              {
                id: 3,
                content: 'privacy_policy.section_4.paragraph_2.li_3',
              },
              {
                id: 4,
                content: 'privacy_policy.section_4.paragraph_2.li_4',
              },
              {
                id: 5,
                content: 'privacy_policy.section_4.paragraph_2.li_5',
              },
              {
                id: 6,
                content: 'privacy_policy.section_4.paragraph_2.li_6',
              },
            ],
          },
          {
            id: 3,
            type: 'text',
            content: 'privacy_policy.section_4.paragraph_3',
          },
          {
            id: 4,
            type: 'text',
            content: 'privacy_policy.section_4.paragraph_4',
          },
        ],
      },
    ],
  },
  {
    id: 5,
    title: 'privacy_policy.section_5.title',
    content: [
      {
        id: 1,
        type: 'section',
        paragraphs: [
          {
            id: 1,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_1',
          },
          {
            id: 2,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_2',
          },
          {
            id: 3,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_3',
          },
          {
            id: 4,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_4',
          },
          {
            id: 5,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_5',
          },
          {
            id: 6,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_6',
          },
          {
            id: 7,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_7',
          },
          {
            id: 8,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_8',
          },
          {
            id: 9,
            type: 'text',
            content: 'privacy_policy.section_5.paragraph_9',
          },
        ],
      },
    ],
  },
];
